/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { CommentsBaseService } from '../comments-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CommentDataEntry } from '../models/comment-data-entry';
import { FileModel } from '../models/file-model';
import { NewCommentDto } from '../models/new-comment-dto';
import { ReferencePropertyWithResolved } from '../models/reference-property-with-resolved';
import { UpdateCommentDto } from '../models/update-comment-dto';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class CommentControllerService extends CommentsBaseService {

  /**
   * Path part for operation commentControllerGetAudienceList
   */
  static readonly CommentControllerGetAudienceListPath = '/v1/comments/audience-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAudienceList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAudienceList$Response(params: {
    keyword: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReferencePropertyWithResolved>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerGetAudienceListPath, 'get');
    if (params) {
      rb.query('keyword', params.keyword, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReferencePropertyWithResolved>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAudienceList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAudienceList(params: {
    keyword: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReferencePropertyWithResolved>> {

    return this.getAudienceList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReferencePropertyWithResolved>>) => r.body as Array<ReferencePropertyWithResolved>)
    );
  }

  /**
   * Path part for operation commentControllerGetMentionsList
   */
  static readonly CommentControllerGetMentionsListPath = '/v1/comments/{entityId}/{entryId}/mentions-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMentionsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMentionsList$Response(params: {
    entryId: string;
    entityId: string;
    keyword: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<ReferencePropertyWithResolved>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerGetMentionsListPath, 'get');
    if (params) {
      rb.path('entryId', params.entryId, {});
      rb.path('entityId', params.entityId, {});
      rb.query('keyword', params.keyword, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ReferencePropertyWithResolved>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMentionsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMentionsList(params: {
    entryId: string;
    entityId: string;
    keyword: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<ReferencePropertyWithResolved>> {

    return this.getMentionsList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ReferencePropertyWithResolved>>) => r.body as Array<ReferencePropertyWithResolved>)
    );
  }

  /**
   * Path part for operation commentControllerGetCommentsAttachmentsRelatedTo
   */
  static readonly CommentControllerGetCommentsAttachmentsRelatedToPath = '/v1/{entity}/{relatedToId}/attachments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommentsAttachmentsRelatedTo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsAttachmentsRelatedTo$Response(params: {
    entity: string;
    relatedToId: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<null | FileModel>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerGetCommentsAttachmentsRelatedToPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('relatedToId', params.relatedToId, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<null | FileModel>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCommentsAttachmentsRelatedTo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsAttachmentsRelatedTo(params: {
    entity: string;
    relatedToId: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<null | FileModel>> {

    return this.getCommentsAttachmentsRelatedTo$Response(params).pipe(
      map((r: StrictHttpResponse<Array<null | FileModel>>) => r.body as Array<null | FileModel>)
    );
  }

  /**
   * Path part for operation commentControllerGetCommentsRelatedToCount
   */
  static readonly CommentControllerGetCommentsRelatedToCountPath = '/v1/{entity}/{relatedToId}/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommentsRelatedToCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsRelatedToCount$Response(params: {
    entity: string;
    relatedToId: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerGetCommentsRelatedToCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('relatedToId', params.relatedToId, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCommentsRelatedToCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsRelatedToCount(params: {
    entity: string;
    relatedToId: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.getCommentsRelatedToCount$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation commentControllerUpdateComment
   */
  static readonly CommentControllerUpdateCommentPath = '/v1/{entity}/{relatedToId}/{commentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateComment$Response(params: {
    entity: string;
    relatedToId: string;
    commentId: string;
    extraParams?: HttpParams,
    context?: HttpContext

    /**
     * update comment
     */
    body?: UpdateCommentDto
  }): Observable<StrictHttpResponse<CommentDataEntry>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerUpdateCommentPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('relatedToId', params.relatedToId, {});
      rb.path('commentId', params.commentId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentDataEntry>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateComment(params: {
    entity: string;
    relatedToId: string;
    commentId: string;
    extraParams?: HttpParams,
    context?: HttpContext

    /**
     * update comment
     */
    body?: UpdateCommentDto
  }): Observable<CommentDataEntry> {

    return this.updateComment$Response(params).pipe(
      map((r: StrictHttpResponse<CommentDataEntry>) => r.body as CommentDataEntry)
    );
  }

  /**
   * Path part for operation commentControllerGetCommentsRelatedTo
   */
  static readonly CommentControllerGetCommentsRelatedToPath = '/v1/{entity}/{relatedToId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCommentsRelatedTo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsRelatedTo$Response(params: {
    entity: string;
    relatedToId: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<CommentDataEntry>>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerGetCommentsRelatedToPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('relatedToId', params.relatedToId, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommentDataEntry>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCommentsRelatedTo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCommentsRelatedTo(params: {
    entity: string;
    relatedToId: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<CommentDataEntry>> {

    return this.getCommentsRelatedTo$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommentDataEntry>>) => r.body as Array<CommentDataEntry>)
    );
  }

  /**
   * Path part for operation commentControllerCreateComment
   */
  static readonly CommentControllerCreateCommentPath = '/v1/{entity}/{relatedToId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createComment()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createComment$Response(params: {
    entity: string;
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext

    /**
     * Whether the post is pinned or not.
     */
    body?: NewCommentDto
  }): Observable<StrictHttpResponse<CommentDataEntry>> {

    const rb = new RequestBuilder(this.rootUrl, CommentControllerService.CommentControllerCreateCommentPath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('relatedToId', params.relatedToId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommentDataEntry>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createComment$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createComment(params: {
    entity: string;
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext

    /**
     * Whether the post is pinned or not.
     */
    body?: NewCommentDto
  }): Observable<CommentDataEntry> {

    return this.createComment$Response(params).pipe(
      map((r: StrictHttpResponse<CommentDataEntry>) => r.body as CommentDataEntry)
    );
  }

}
